export default "__VITE_ASSET__029c3811__"